export default __webpack_public_path__ + "static/media/logo_caer.262bb05c.png";